import React from 'react';
import {Form, Formik} from 'formik';

import MultipleRangeSlider from 'components/multipleRangeSlider';

import GroupButton from './groupButton';
import FilterOptions from './filterOptions';
import {useLocation} from 'react-router';
import {profileOptions, typeOptions} from './utilities';
import FilterProfile from './filterProfiles';
import IsGrade from './isGrade';
interface FilterFormProps {
  filterFields: IFilters;
  onclose: (isClose: boolean) => void;
  setFilter: (filters: IFilters) => void;
}
const FilterForm = ({filterFields, onclose, setFilter}: FilterFormProps) => {
  const {state} = useLocation();

  return (
    <Formik
      enableReinitialize
      initialValues={{
        end_price: filterFields.end_price ? filterFields.end_price : undefined,
        start_price: filterFields.start_price
          ? filterFields.start_price
          : undefined,
        type: filterFields.type ? filterFields.type : undefined,
        type_profile : filterFields.type_profile ? filterFields.type_profile : undefined,
        is_grade :  undefined ,
      }}
      onSubmit={values => {
        setFilter(values);
        onclose(false);
      }}
    >
      {({values, resetForm, setFieldValue}) => (
        <Form className="flex flex-col w-full items-center gap-4 ">
          <div className=" w-full flex justify-end">
            <button
              onClick={() => {
                setFilter({});
                resetForm();
              }}
              className=" text-[14px] font-medium  text-error"
            >
              حذف همه فیلترها
            </button>
          </div>
          {state?.type === '' && (
            <FilterOptions
              options={typeOptions}
            />
          )}
          <FilterProfile options={profileOptions} />
          {values.type?.length === 1 && values.type[0] === "prepayment" ? null : <IsGrade name = "is_grade" isChecked = {values.is_grade} />}

          <div className="flex flex-col w-full py-4">
            <p className="text-[14px] font-medium text-gray-5">
              محدوده قیمت (تومان)
            </p>
            <div className="py-4 flex w-full justify-center items-center">
              <MultipleRangeSlider
                min={0}
                max={999000000}
                maxVal={values.end_price || 999000000}
                minVal={values.start_price || 0}
                setMaxVal={maxVal => setFieldValue('end_price', maxVal)}
                setMinVal={minVal => setFieldValue('start_price', minVal)}
              />
            </div>
          </div>
          <GroupButton
            onClearHandler={() => {
              onclose(false);
              resetForm();
              setFilter({});
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default FilterForm;
